export { default } from './StatementQuestion.js';
